export default "__VITE_ASSET__BHIfImXZ__"